import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
        SelectControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/button-golden', {
        // built-in attributes
        title: 'Button Golden',
        description: 'Button Golden',
        icon: '',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            target: {
                type: 'string',
                default: '',
            },
            text: {
                type: 'string',
                default: 'Text'
            },
            icon: {
                type: 'string',
                default: '',
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                link,
                target,
                text,
                icon,
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            }
            function onTargetChange (target) {
                setAttributes({target: target});
            }
            function onTextChange(text) {
                setAttributes({text: text});
            }
            function onIconChange(icon) {
                setAttributes({icon: icon});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <p><strong>Enter url: (ex: /camps)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>

                        <p><strong>Url target:</strong></p>
                        <SelectControl value={ target } onChange={ onTargetChange } options={ [
                            { label: '', value: '' },
                            { label: '_blank', value: '_blank' },
                            { label: '_self', value: '_self' },
                            { label: '_parent', value: '_parent' },
                            { label: '_top', value: '_top' },
                        ] } />

                        <p><strong>Text</strong></p>
                        <TextControl value={ text } onChange={ onTextChange }></TextControl>

                        <p><strong>Icon</strong></p>
                        <TextControl value={ icon } onChange={ onIconChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a className={ "btn btn-golden" + (classes ? ' ' + classes : '') }>
                    <RichText 
                        key="editable" 
                        tagName="span"
                        placeholder="Text" 
                        value={ text }
                        onChange={ onTextChange } />
                    <span dangerouslySetInnerHTML={{ __html: icon }}></span>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                target,
                text,
                icon,
                classes
            } = attributes;

            return (
                <a className={ "btn btn-golden" + (classes ? ' ' + classes : '') } href={ link } target={ target }>
                    { text }<span dangerouslySetInnerHTML={{ __html: icon }}></span>
                </a>
            );
        },
    });
}